var _clipPath;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWalletIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 22 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-2285.6,-638.208)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Wallet-Icon",
    serifId: "Wallet Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Coin",
    transform: "matrix(1,0,0,1,5.66839,5.98631)"
  }, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2288.89,
    y: 632.195,
    width: 8.256,
    height: 4.544
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.583333,0,0,0.583333,953.723,264.055)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2296,
    cy: 638,
    r: 6,
    style: {
      fill: "none",
      stroke: "rgb(51,57,68)",
      strokeWidth: "1.71px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.662527,0,0,0.662527,779.589,214.767)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2284.39,638.359C2284.1,638.359 2283.83,638.321 2283.59,638.247C2283.35,638.172 2283.12,638.041 2282.9,637.853C2282.85,637.806 2282.81,637.753 2282.78,637.693C2282.75,637.633 2282.73,637.573 2282.73,637.514C2282.73,637.416 2282.77,637.329 2282.84,637.255C2282.91,637.18 2283,637.143 2283.1,637.143C2283.18,637.143 2283.26,637.168 2283.32,637.219C2283.48,637.352 2283.64,637.452 2283.8,637.52C2283.96,637.588 2284.16,637.623 2284.39,637.623C2284.55,637.623 2284.7,637.598 2284.83,637.549C2284.96,637.5 2285.07,637.434 2285.15,637.351C2285.23,637.267 2285.27,637.172 2285.27,637.066C2285.27,636.938 2285.23,636.829 2285.16,636.739C2285.08,636.65 2284.96,636.574 2284.8,636.512C2284.65,636.45 2284.45,636.402 2284.2,636.368C2283.97,636.334 2283.77,636.282 2283.6,636.211C2283.42,636.141 2283.27,636.051 2283.16,635.943C2283.04,635.834 2282.95,635.706 2282.89,635.559C2282.83,635.411 2282.8,635.246 2282.8,635.063C2282.8,634.785 2282.87,634.548 2283.02,634.352C2283.16,634.156 2283.35,634.007 2283.6,633.904C2283.84,633.802 2284.11,633.751 2284.4,633.751C2284.68,633.751 2284.94,633.792 2285.17,633.875C2285.41,633.959 2285.6,634.064 2285.75,634.192C2285.88,634.29 2285.94,634.403 2285.94,634.531C2285.94,634.625 2285.9,634.711 2285.83,634.787C2285.76,634.864 2285.67,634.903 2285.57,634.903C2285.51,634.903 2285.45,634.883 2285.4,634.845C2285.33,634.785 2285.24,634.729 2285.12,634.675C2285.01,634.622 2284.89,634.577 2284.76,634.541C2284.63,634.505 2284.51,634.487 2284.4,634.487C2284.22,634.487 2284.06,634.51 2283.94,634.557C2283.81,634.604 2283.72,634.668 2283.65,634.749C2283.59,634.83 2283.56,634.924 2283.56,635.031C2283.56,635.159 2283.59,635.264 2283.67,635.347C2283.74,635.431 2283.85,635.497 2283.99,635.546C2284.13,635.595 2284.3,635.639 2284.5,635.677C2284.75,635.724 2284.98,635.779 2285.17,635.843C2285.37,635.907 2285.53,635.989 2285.66,636.09C2285.78,636.19 2285.88,636.316 2285.94,636.467C2286.01,636.619 2286.04,636.803 2286.04,637.021C2286.04,637.298 2285.96,637.537 2285.81,637.738C2285.66,637.938 2285.45,638.092 2285.2,638.199C2284.95,638.305 2284.69,638.359 2284.39,638.359ZM2284.86,638.704C2284.86,638.815 2284.82,638.908 2284.74,638.983C2284.67,639.057 2284.58,639.095 2284.47,639.095C2284.36,639.095 2284.27,639.057 2284.2,638.983C2284.12,638.908 2284.09,638.815 2284.09,638.704L2284.09,633.559C2284.09,633.448 2284.13,633.355 2284.2,633.28C2284.28,633.205 2284.37,633.168 2284.48,633.168C2284.59,633.168 2284.68,633.205 2284.75,633.28C2284.82,633.355 2284.86,633.448 2284.86,633.559L2284.86,638.704Z",
    style: {
      fill: "rgb(51,57,68)",
      fillRule: "nonzero"
    }
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Wallet",
    d: "M2300.45,639.473L2302.09,639.061C2302.26,639.02 2302.42,639 2302.59,639C2303.71,639 2304.63,639.919 2304.63,641.037L2304.63,642.694L2305.31,642.694C2306.43,642.694 2307.35,643.614 2307.35,644.733L2307.35,656.962C2307.35,658.08 2306.43,659 2305.31,659L2287.64,659C2286.52,659 2285.6,658.08 2285.6,656.962L2285.6,644.733C2285.6,643.649 2286.47,642.745 2287.55,642.696L2295.63,640.676C2295.36,641.127 2295.19,641.644 2295.15,642.198L2293.16,642.694L2303.27,642.694L2303.27,641.037C2303.27,640.664 2302.96,640.359 2302.59,640.359C2302.53,640.359 2302.48,640.366 2302.42,640.379L2301.59,640.588C2301.3,640.134 2300.91,639.752 2300.45,639.473Z",
    style: {
      fill: "rgb(51,57,68)",
      fillRule: "nonzero"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletIcon);
export default __webpack_public_path__ + "static/media/wallet_icon.dee42764ebef04d221fdece6a4e9729b.svg";
export { ForwardRef as ReactComponent };